import Page from '../../components/page/Page'
import s from "./Rules.module.scss"

export default function Rule2() {
  return (
    <Page>
      <h1>Rule 2 - Don't Grief</h1>
      <div className={s.content}>
        <span>As an alternate way of understanding it, rule 2 can be broken down into sub-rules:</span>
        <span><span className={s.subrule}>2.1</span> Don't grief other players, as in destroying or altering something they've built without their permission.</span>
        <span><span className={s.subrule}>2.2</span> Don't steal from other players, including taking from unclaimed areas that aren't yours.</span>
        <span><span className={s.subrule}>2.3</span> Don't attack other players unless they give permission or initiate combat first.</span>
        <h4>Examples:</h4>
        <span><span>Example 1 -</span> Taking items from unclaimed areas or abandoned builds: <span className={s.subrule}>Not Allowed</span></span>
        <span><span>Example 2 -</span> Unprovoked or non-consensual PvP: <span className={s.subrule}>Not Allowed</span></span>
        <span><span>Example 3 -</span> Destroying another player's build without permission: <span className={s.subrule}>Not Allowed</span></span>
      </div>
    </Page>
  )
}
